// Basic ellipsis style
export var baseEllipsisStyle = "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"; // Block ellipsis style

export var ellipsisStyle = "\n  " + baseEllipsisStyle + "\n  max-width: 100%;\n";